import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
@Component({
  selector: 'app-shopping-cart-shipping-fee-progress',
  imports: [MatProgressBarModule, MatIconModule],
  templateUrl: './shopping-cart-shipping-fee-progress.html',
  styleUrl: './shopping-cart-shipping-fee-progress.scss',
})
export class ShoppingCartShippingFeeProgress implements OnChanges {
  @Input({ required: true }) subtotal: number = 0;
  @Input() freeShippingThreshold: number = 99;
  progress: number = 0;
  left: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    this.progress = Math.floor(
      (this.subtotal / this.freeShippingThreshold) * 100
    );
    this.left = Math.ceil(this.freeShippingThreshold - this.subtotal).toFixed(
      0
    );
  }
}
